import api from '../../api/api';

export interface AllProduct {
    id: number;
    title: string;
    price: number;
    discount: number;
    discount_price: number;
    images: string[];
    sold_count?: number;
    view_count?: number;
    rating?: number;
}

export const getAllProducts = async (): Promise<AllProduct[]> => {
  try {
    const response = await api.get('/products/all-products/');
    if (!response.data || !Array.isArray(response.data)) {
      console.warn("Kutilgan mahsulotlar ma'lumotlari topilmadi:", response.data);
      return []; // fallback bo‘sh array
    }
    return response.data;
} catch (error) {
    console.warn("Main mahsulotlarni olishda xatolik:", error);
    return []; // fallback bo'sh array
  }
};

export const topProduct = async () => {
  try {
    const response = await api.get(`/products/top/`);
    return response.data;
  } catch (error) {
    console.warn("Top products API not available:", error);
    return [];
  }
};

export const topAllProduct = async () => {
  try {
    const response = await api.get(`/products/top-products/`);
    return response.data;
  } catch (error) {
    console.warn("Top products API not available:", error);
    return [];
  }
};


export const topBanners = async () => {
  const isMobile = window.innerWidth < 768;
  try {
    const response = await api.get(`/banners/?type=${isMobile ? "phone" : "laptop"}`);
    const data = response.data;

    // Har doim bir xil formatda qaytaramiz
    if (isMobile) {
      // Mobil uchun: oddiy arrayni { b: [], t: [] } shaklga o‘tkazamiz
      return { b: data || [], t: [] };
    } else {
      // Laptop uchun: obyektni to‘g‘ridan-to‘g‘ri qaytaramiz
      return data;
    }
  } catch (error) {
    console.warn("Bannerlarni olishda xatolik:", error);
    return { b: [], t: [] }; // fallback
  }
};

